import React, { useState, useEffect } from 'react';
import { Collapse, Container, NavbarToggler, NavLink } from 'reactstrap';
import Scrollspy from 'react-scrollspy';
import { Link } from 'react-router-dom';
import LightDark from './Components/LightDark';
import logodark from '../assets/images/hrplus.png';
import logolight from '../assets/images/hrplus.png';
import { useDispatch, useSelector } from 'react-redux';
import '../App.css';
import LanguageDropdown from './Components/LanguageDropdown';
import { useTranslation } from 'react-i18next';
import DemoRequest from '../pages/Auth/DemoRequest';
import { changeLayoutModeAction } from '../store/layout/slice'; // changeLayoutMode o‘rniga changeLayoutModeAction
import { appConfig } from '../config';
import { appPaths } from '../constants/paths';
import { toggleShowDemoRequest } from '../store/requestDemo/slice';

const Header = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isOpenMenu, setisOpenMenu] = useState(false);
    const [navClass, setnavClass] = useState('');

    const { showDemoRequest = false } = useSelector(state => state.requestDemo || {});

    const toggle = () => setisOpenMenu(!isOpenMenu);

    useEffect(() => {
        const scrollNavigation = () => {
            const scrollup = document.documentElement.scrollTop;
            setnavClass(scrollup > 50 ? 'is-sticky' : '');
        };
        window.addEventListener('scroll', scrollNavigation, true);
        return () => window.removeEventListener('scroll', scrollNavigation, true);
    }, []);

    const { layoutModeType } = useSelector(state => ({
        layoutModeType: state.Layout.layoutModeType,
    }));

    useEffect(() => {
        if (layoutModeType) {
            dispatch(changeLayoutModeAction(layoutModeType)); // changeLayoutMode o‘rniga changeLayoutModeAction
        }
    }, [layoutModeType, dispatch]);

    const onChangeLayoutMode = (value) => {
        dispatch(changeLayoutModeAction(value)); // changeLayoutMode o‘rniga changeLayoutModeAction
    };

    return (
        <React.Fragment>
            <nav className={'navbar navbar-expand-lg navbar-landing p-0 fixed-top ' + navClass} id="navbar">
                <Container>
                    <Link className="navbar-brand" to={appPaths.DASHBOARD_MAIN}>
                        <img src={logodark} className="card-logo card-logo-dark" alt="logo dark" height="45" />
                        <img src={logolight} className="card-logo card-logo-light" alt="logo light" height="45" />
                    </Link>

                    <NavbarToggler
                        className="navbar-toggler py-0 fs-20 text-body"
                        onClick={toggle}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <i className="mdi mdi-menu"></i>
                    </NavbarToggler>

                    <Collapse isOpen={isOpenMenu} className="navbar-collapse" id="navbarSupportedContent">
                        <Scrollspy
                            offset={-18}
                            items={['hero', 'features', 'prices', 'services', 'plans', 'categories', 'contact']}
                            currentClassName="active"
                            className="navbar-nav mx-auto mt-2 mt-lg-0"
                            id="navbar-example"
                        >
                            <li className="nav-item">
                                <NavLink href="/home#hero">{t('t-main')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="/home#features">{t('t-features')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="/home#prices">{t('t-prices')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="/home#services">{t('t-services')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="/home#plans">{t('t-solutions')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="/home#categories">{t('t-clients')}</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink href="/home#contact">{t('t-contact')}</NavLink>
                            </li>
                        </Scrollspy>
                        <div>
                            <LightDark layoutMode={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} />
                        </div>
                        <div className="ms-1" style={{ paddingBottom: '5px' }}>
                            <LanguageDropdown />
                        </div>
                        <div className="ms-lg-3 me-lg-n5 text-nowrap">
                            <button className="btn btn-success" onClick={() => dispatch(toggleShowDemoRequest(true))}>
                                {t('t-demo-request')}
                            </button>
                            <Link
                                className="btn btn-primary ms-2"
                                to={appConfig.baseUrl.concat('/login')}
                                target="_blank"
                            >
                                {t('t-login')}
                            </Link>
                        </div>
                    </Collapse>
                </Container>
            </nav>
            <DemoRequest isOpen={showDemoRequest} toggle={() => dispatch(toggleShowDemoRequest())} />
        </React.Fragment>
    );
};

export default Header;